var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07599 7.41645L9.19605 10.2432L11.3161 7.41645H9.7623L9.7623 4.06394H8.7623L8.7623 7.41645H7.07599ZM5.03125 12.4361V10.2432H4.03125V12.4361C4.03125 13.2645 4.70282 13.9361 5.53125 13.9361H12.4712C13.2997 13.9361 13.9712 13.2645 13.9712 12.4361V10.2432H12.9712V12.4361C12.9712 12.7122 12.7474 12.9361 12.4712 12.9361H5.53125C5.25511 12.9361 5.03125 12.7122 5.03125 12.4361Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6a7fd6c684e9dc0fdd6fc4383a75b00b.svg";
export { ForwardRef as ReactComponent };